import { Component, h } from '@stencil/core';
import printfectionLogo from '../../assets/header/printfection.svg';

@Component({
  tag: 'ci-solutions',
  styleUrl: 'ci-solutions.scss',
})
export class ciSolutions {
  render() {
    const click_section = "solutions";
    return (
      <div class="ciSolutions">
        <div class="ciSolutions-content">
          <div class="ciSolutions-column">
            <span data-href={`${process.env.CI_HOSTNAME}/ink/group-order-form`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Group Order">
              <span class="ciSolutions-title">
                Group Order
              </span>
              <span class="ciSolutions-subtitle">
                Easily collect sizes, addresses, and payments from your group.
              </span>
            </span>
            <span data-href={`${process.env.CI_HOSTNAME}/inventory-distribution`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Inventory & Distribution">
              <span class="ciSolutions-title">
                Inventory & Distribution
              </span>
              <span class="ciSolutions-subtitle">
                Store and send branded swag anywhere. Think of us as your online supply closet!
              </span>
            </span>
            <span data-href={`${process.env.CI_HOSTNAME}/fundraising`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Fundraising">
              <span class="ciSolutions-title">
                Fundraising
              </span>
              <span class="ciSolutions-subtitle">
                Raise money and awareness for anything you care about.
              </span>
            </span>
            <span data-href={`${process.env.CI_HOSTNAME}/onlinestores`}
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Online Stores">
              <span class="ciSolutions-title">
                Online Stores
              </span>
              <span class="ciSolutions-subtitle">
                Create a branded storefront to sell merchandise to your community.
              </span>
            </span>
          </div>
          <div class="ciSolutions-column">
            <span data-href="https://www.printfection.com"
            class="ciSolutions-link js-menu-span-link js-ciHeader-track"
            data-section={click_section}
            data-link="Printfection">
              <span class="ciSolutions-image">
                <img class="ciSolutions-printfection" src={printfectionLogo} alt="Printfection" />
              </span>
              <span class="ciSolutions-subtitle">
                In need of custom kits, detailed reporting on swag usage, white-glove customer service, and global shipping? Check out our swag management solution made for Enterprise businesses.﻿
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}
